import React from 'react';
import Layout from '../main/Layout/Layout';
import {isAuthenticated} from '../auth/authenticate';
import {Link} from 'react-router-dom';

function AdminDashboard(props) {
    // const {user:{name,email,role}} = isAuthenticated().data; //value in local store {data:{user:{_id,name,email,role}}}
    let _id,name,email,role;
    if(isAuthenticated().data)
    {
         _id = isAuthenticated().data.user._id; //value in local store {data:{user:{_id,name,email,role}}}
        name= isAuthenticated().data.user.name; 
         email = isAuthenticated().data.user.email;
         role = isAuthenticated().data.user.role; 

    }else{
        _id=isAuthenticated()._id;
        name=isAuthenticated().name;
        email=isAuthenticated().email;
        role=0;
    }
    const adminInfo = () => {
        return (
            <div className="card mb-5">
                <h3 className="card-header">Information</h3>
                <ul className="list-group">
                    <li className="list-group-item">{name}</li>
                    <li className="list-group-item">{email}</li>
                    <li className="list-group-item">
                        {role === 1 ? "Admin" : "Registered User"}
                    </li>
                </ul>
            </div>
        );
    };
    const adminLinks = () => {
        return (
            <div className="card">
                <h4 className="card-header">Admin Links</h4>
                <ul className="list-group">
                    <li className="list-group-item">
                        <Link className="nav-link" to="/category/create">
                            Create Category
                        </Link>
                    </li>
                    <li className="list-group-item">
                        <Link className="nav-link" to="/product/create">
                            Create Product
                        </Link>
                    </li>
                    <li className="list-group-item">
                        <Link className="nav-link" to="/admin/orders">
                            View Orders
                        </Link>
                    </li>
                    <li className="list-group-item">
                        <Link className="nav-link" to="/admin/products">
                            Manage Products
                        </Link>
                    </li>
                </ul>
            </div>
        );
    };

    return (
        <React.Fragment>
            <Layout/>
            <br/>
            <div className="container">
            <div className="row">
                <div className="col-3">{adminLinks()}</div>
                <div className="col-9">
                    {adminInfo()}
                </div>
            </div>
            </div>

        </React.Fragment>
    );
}

export default AdminDashboard;